export default {
  COMPLETEDORDERS: 'Completed Orders',
  TOTALORDERS: 'Total Orders',
};
